import { Box, Grid, Tooltip, Typography } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { formatNumber, orderToolTipContentEnglish, orderToolTipContentFrench } from 'src/constants';

const OrderSectionCard = ({ icon, path, title, value, bgColor, step }) => {
  const navigate = useNavigate();
  const handleNavigate = (path) => {
    navigate(path?.to, { state: path?.status });
  };

  const { language } = useSelector((state) => state.auth);

  return (
    <Tooltip title={language === 'ENGLISH' ? orderToolTipContentEnglish[title] : orderToolTipContentFrench[title]}>
      <Grid
        onClick={() => path?.to && handleNavigate(path)}
        className="card"
        item
        xs={5}
        md={2}
        sx={{
          height: '140px',
          bgcolor: bgColor,
          color: '#fff',
          minWidth: {
            sm: '250px',
            xs: '280px',
          },
          borderRadius: '12px',
          display: 'flex',
          flexDirection: 'column',
          padding: 2,
          position: 'relative',
        }}
      >
        <Box
          sx={{
            height: '36px',
            width: '36px',
            borderRadius: '50%',
            position: 'absolute',
            bgcolor: '#fff',
            top: '-12%',
            right: '-5%',
            boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: bgColor,
            fontWeight: 900,
          }}
        >
          {step}
        </Box>
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              minHeight: '50px',
              minWidth: '24%',
              borderRadius: '50%',
              bgcolor: '#fff',
              color: bgColor,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {icon}
          </Box>
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            {t(`labels.${title}`)}
          </Typography>
        </Box>
        <Box sx={{ height: '110px', width: '100%', display: 'flex', alignItems: 'center', paddingLeft: '1rem' }}>
          <Typography variant="h4" sx={{ fontWeight: 500 }}>
            {formatNumber(value)}
          </Typography>
        </Box>
      </Grid>
    </Tooltip>
  );
};

export default OrderSectionCard;
